<template>
    <header class="c-20-t rlt">
      <div class="h-10"></div>
      <div :class="'w-f '+(fixed?'fxd':'abs')+' .t .s -z-2'">
        <div class="--bg abs .t w-f -pe-n h-13"></div>
        <nav class="h-10 rlt">
          <Container class="h-i b b-a-c b-j-sb" :padding='true'>
            <div class="b b-a-c">
              <router-link v-if="$route.name !== 'Home'" to='/' class="unt btn-n u-8 CASE c-20-t font-ar-f"><i class="material-icons m-e-3 -i-x">arrow_back</i></router-link>
              <router-link to='/' class="c-20-t">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 160.64 160.64" class="h-8"><defs><svg:style>.cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}</svg:style><linearGradient id="linear-gradient" x1="85.71" y1="1.73" x2="106.97" y2="158.92" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#33c599"></stop><stop offset="0.46" stop-color="#1dde99"></stop><stop offset="1" stop-color="#0f9"></stop></linearGradient><linearGradient id="linear-gradient-2" x1="140.24" y1="92.37" x2="148.48" y2="153.29" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#33b699"></stop><stop offset="1" stop-color="#0f9"></stop></linearGradient><linearGradient id="linear-gradient-3" x1="12.43" y1="92.05" x2="16.05" y2="118.8" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#3c9"></stop><stop offset="0.14" stop-color="#26d999"></stop><stop offset="0.44" stop-color="#1e9"></stop><stop offset="0.73" stop-color="#04fb99"></stop><stop offset="1" stop-color="#0f9"></stop></linearGradient></defs><polygon points="89.36 119.3 12.06 119.19 2.52 93.39 79.82 93.5 89.36 119.3" style="fill: currentColor;"></polygon><polygon points="27.51 154.78 82.57 5.86 55.06 5.86 0 154.78 27.51 154.78" style="fill: currentColor;"></polygon><polygon class="cls-1" points="110.08 154.68 55.06 5.87 82.57 5.86 137.62 154.78 110.08 154.68"></polygon><polygon class="cls-2" points="137.5 154.78 160.2 93.39 132.69 93.39 123.81 117.41 137.5 154.78"></polygon><polygon class="cls-3" points="13.15 119.19 12.06 119.19 2.52 93.39 22.7 93.39 13.15 119.19"></polygon></svg>
              </router-link>
              <a href='https://www.google.com/search?q=COVID-19+Alert' class="unt btn-n m-s-5 u-8 CASE c-20-t font-ar-f" target="_blank"><i class="material-icons">school</i></a>
              <router-link to='/widgets' class="unt btn-n u-8 CASE c-20-t font-ar-f"><SwingTitle style="margin-top: 0 !important;"><i class="material-icons">code</i></SwingTitle></router-link>
            </div>
            <div class="b">
              <label class="unt btn-n u-8 c-20-t swt font-ar-f CASE"><SwingTitle style="margin-top: 0 !important;"><i class="material-icons">brightness_2</i></SwingTitle><input type="checkbox" @click="changeTheme()"></label>
              <div class="unt btn-n u-8 c-20-t CASE font-ar-f" v-if="$i18n.locale != 'ar'" @click="$i18n.locale = 'ar'"><i class="material-icons">translate</i><div class="unt bdg bdg-f bdg-s p-x-1 #9 b-a-s">ع</div></div>
              <div class="unt btn-n u-8 c-20-t CASE font-ar-f" v-if="$i18n.locale != 'en'" @click="$i18n.locale = 'en'"><i class="material-icons">translate</i><div class="unt bdg bdg-f bdg-s p-x-1">EN</div></div>
            </div>
          </Container>
        </nav>
      </div>
    </header>
</template>
<script>
import { mapState } from 'vuex'
// Components
import Container from '../components/physia/Container'
import SwingTitle from '../components/SwingTitle'
export default {
  props: {
    fixed: {
      default: true
    }
  },
  computed: {
    ...mapState(['W', 'theme'])
  },
  components: {
    Container,
    SwingTitle
  },
  methods: {
    changeTheme () {
      this.$router.push({ query: { ...this.$route.query, theme: (this.$store.state.theme === 'light' ? 'dark' : 'light') } })
    }
  }
}
</script>
<style lang="scss">
.--bg {
  background-image: url(~@/assets/bg.png); background-size: cover;mask-image: linear-gradient(rgb(0, 0, 0) ,rgba(0, 0, 0, 0.3) , transparent);
}
</style>
